export const PAGE_LOADED = 'page loaded';
export const SET_LOADING_ON = 'set loading on';
export const SET_LOADING_OFF = 'set loading off';

export const SET_FORMSUBMITTING_ON = "SET_FORMSUBMITTING_ON";
export const SET_FORMSUBMITTING_OFF = "SET_FORMSUBMITTING_OFF";

export const pageLoaded = {
    type: PAGE_LOADED
};

export const setLoading = isLoading => ({
    type: isLoading ? SET_LOADING_ON : SET_LOADING_OFF,
    payload: isLoading,
});

export const setFormSubmitting = isSubmitting => ({
    type: isSubmitting ? SET_FORMSUBMITTING_ON : SET_FORMSUBMITTING_OFF,
    payload: isSubmitting,
});

